"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_TENANT = void 0;
var effects_1 = require("redux-saga/effects");
var store_1 = __importDefault(require("store"));
var Profile_1 = __importDefault(require("Service/AccallioCloud/Profile"));
var antd_1 = require("antd");
var actions_1 = __importDefault(require("./actions"));
function SET_TENANT(_a) {
    var id, accessToken, options, loadTenantResponse, tenants, foundCurrent, current, tenantData, error_1;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                id = payload.id;
                return [4 /*yield*/, effects_1.select(function (state) { var _a; return ({ accessToken: (_a = state.oidc.user) === null || _a === void 0 ? void 0 : _a.access_token }); })];
            case 1:
                accessToken = (_b.sent()).accessToken;
                options = { 'headers': { 'Authorization': "Bearer " + accessToken } };
                return [4 /*yield*/, Profile_1.default.currentUserApi.getTenants(options).catch(function (e) {
                        return antd_1.notification.error({
                            message: 'Unable to load current tenant',
                            description: e.message,
                        });
                    })];
            case 2:
                loadTenantResponse = _b.sent();
                tenants = loadTenantResponse.data.items;
                _b.label = 3;
            case 3:
                _b.trys.push([3, 7, , 8]);
                if (!(tenants != undefined)) return [3 /*break*/, 6];
                foundCurrent = tenants.filter(function (availableTenant) { return availableTenant.id === id; });
                current = foundCurrent.length ? foundCurrent[0] : tenants[0];
                tenantData = {
                    current: current,
                    available: tenants.filter(function (t) { return t.isUserTenantAdmin === true; }),
                };
                return [4 /*yield*/, store_1.default.set('app.tenant', JSON.stringify(tenantData))];
            case 4:
                _b.sent();
                return [4 /*yield*/, effects_1.put({
                        type: 'tenant/SET_STATE',
                        payload: tenantData,
                    })];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [3 /*break*/, 8];
            case 7:
                error_1 = _b.sent();
                console.log(error_1);
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
exports.SET_TENANT = SET_TENANT;
function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.all([effects_1.takeEvery(actions_1.default.SET_TENANT, SET_TENANT)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.default = rootSaga;
//# sourceMappingURL=sagas.js.map